import React from 'react';
import './MarqueeTechnology.scss';

const row1 = ["React", "JavaScript", "TypeScript", "HTML", "CSS", "SCSS", "Redux", "Next.js", "TailwindCSS", "Three.JS"];
const row2 = ["Node.js", "Express", "MongoDB", "PostgreSQL", "MySQL", "Adobe Photoshop", "Adobe Premiere Pro"];
const row3 = ["React Native", "WordPress", "Shopify", "Figma", "Canva", "After Effects", "3D Product Visualization", "Blender"];

function MarqueeRow({ items, className }) {
  return (
    <div className={`tm-row ${className}`}>
      <div className="tm-track">
        {items.map((t, i) => (
          <span className="tm-item" key={`a-${i}`}>{t}</span>
        ))}
        {/* Duplicate for seamless loop */}
        {items.map((t, i) => (
          <span className="tm-item" key={`b-${i}`} aria-hidden="true">{t}</span>
        ))}
      </div>
    </div>
  );
}

export default function MarqueeTechnology() {
  return (
    <section className="tm">
      <MarqueeRow items={row1} className="tm-left" />
      <MarqueeRow items={row2} className="tm-right" />
      <MarqueeRow items={row3} className="tm-left" />
    </section>
  );
}
